import React from 'react';
import PropTypes from 'prop-types';
import {ContactFormModal as ContactModal, sendToSalesforce, useDispatch, useGuideConfig, contactFormCommonFields} from '@ignitesales/neuro-application';

const ContactFormModal = ({ isOpen, onComplete, useAppointmentFlow, ...rest }) => {
    const dispatch = useDispatch();
    const { isUsingSalesforce, isBranchGuide } = useGuideConfig();

    const onFormComplete = () => {
        if(isUsingSalesforce) {
            dispatch(sendToSalesforce());
        }
        onComplete && onComplete();
    }

    const dialogueConsumerFields = [
      contactFormCommonFields.firstName,
      contactFormCommonFields.lastName,
      contactFormCommonFields.emailAddress,
      contactFormCommonFields.phoneNumber
    ];

    if(isBranchGuide)
        dialogueConsumerFields.push(contactFormCommonFields.customerId);

    return (
        <ContactModal
            isOpen={isOpen}
            onComplete={onFormComplete}
            useAppointmentFlow={useAppointmentFlow}
            className="diana-contactForm"
            fields={dialogueConsumerFields}
            { ...rest }
        />
    );
};

ContactFormModal.propTypes = {
    isOpen: PropTypes.bool,
    useAppointmentFlow: PropTypes.bool,
    onComplete: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

ContactFormModal.defaultProps = {
    isOpen: false,
    useAppointmentFlow: false
};

export default ContactFormModal;
